// Mock data for parents/carers - SAT V4 Zone
import type { ParentCarer } from '../../types';
import { mockPupils } from './pupils';

const firstNames = [
  'James',
  'Sarah',
  'Michael',
  'Emma',
  'David',
  'Sophie',
  'Robert',
  'Emily',
  'William',
  'Olivia',
  'Richard',
  'Charlotte',
  'Thomas',
  'Amelia',
  'Christopher',
  'Mia',
  'Daniel',
  'Isabella',
  'Matthew',
  'Jessica',
];
const lastNames = [
  'Smith',
  'Jones',
  'Williams',
  'Taylor',
  'Brown',
  'Davies',
  'Evans',
  'Wilson',
  'Thomas',
  'Roberts',
  'Johnson',
  'Lewis',
  'Walker',
  'Robinson',
  'Wood',
  'Thompson',
  'White',
  'Watson',
  'Jackson',
  'Wright',
];
const _titles: ('Mr' | 'Mrs' | 'Ms' | 'Miss' | 'Dr')[] = ['Mr', 'Mrs', 'Ms', 'Miss', 'Dr'];
const relationships: ParentCarer['relationship'][] = ['mother', 'father', 'guardian', 'carer'];

const cities = [
  'London',
  'Manchester',
  'Birmingham',
  'Leeds',
  'Liverpool',
  'Sheffield',
  'Bristol',
  'Nottingham',
  'Leicester',
  'Newcastle',
];
const streetNames = [
  'High Street',
  'Station Road',
  'Church Lane',
  'Park Avenue',
  'Victoria Road',
  'Oak Drive',
  'Maple Close',
  'Cedar Way',
  'Elm Grove',
  'Willow Lane',
];

// Generate parents based on pupil data
const parentIds = new Set<string>();
for (const pupil of mockPupils) {
  for (const id of pupil.parentCarerIds) {
    parentIds.add(id);
  }
}

export const mockParentCarers: ParentCarer[] = Array.from(parentIds).map((id, index) => {
  const pupilsForParent = mockPupils.filter((p) => p.parentCarerIds.includes(id));
  const pupilLastName = pupilsForParent[0]?.lastName || lastNames[index % lastNames.length];
  const isPrimary = id.endsWith('-1');
  const relationship = isPrimary
    ? Math.random() > 0.5
      ? 'mother'
      : 'father'
    : relationships[Math.floor(Math.random() * relationships.length)];
  const firstName = firstNames[index % firstNames.length];

  return {
    id,
    title: relationship === 'mother' ? (Math.random() > 0.7 ? 'Ms' : 'Mrs') : 'Mr',
    firstName,
    lastName: pupilLastName,
    email: `${firstName.toLowerCase()}.${pupilLastName.toLowerCase()}@email.com`,
    phone: `07${Math.floor(100000000 + Math.random() * 900000000)}`,
    workPhone: Math.random() > 0.6 ? `020${Math.floor(10000000 + Math.random() * 90000000)}` : undefined,
    relationship,
    pupilIds: pupilsForParent.map((p) => p.id),
    isPrimaryContact: isPrimary,
    isEmergencyContact: isPrimary || Math.random() > 0.5,
    canPickup: isPrimary || Math.random() > 0.3,
    receivesReports: isPrimary || Math.random() > 0.4,
    address: {
      line1: `${Math.floor(Math.random() * 200) + 1} ${streetNames[index % streetNames.length]}`,
      city: cities[index % cities.length],
      postcode: `${String.fromCharCode(65 + Math.floor(Math.random() * 26))}${String.fromCharCode(65 + Math.floor(Math.random() * 26))}${Math.floor(Math.random() * 10)} ${Math.floor(Math.random() * 10)}${String.fromCharCode(65 + Math.floor(Math.random() * 26))}${String.fromCharCode(65 + Math.floor(Math.random() * 26))}`,
      country: 'United Kingdom',
    },
  };
});

export default mockParentCarers;
